module.exports = __webpack_public_path__ + "img/meditation--active.fe8e9ac1.svg";